import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "sections" }
const _hoisted_2 = { class: "row-fluid" }
const _hoisted_3 = {
  class: "nav nav-pills",
  role: "tablist"
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = ["href", "aria-selected", "onClick"]
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = ["href", "aria-selected", "onClick"]
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = ["href", "aria-selected", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/me",
            custom: ""
          }, {
            default: _withCtx(({ isExactActive, href, navigate }) => [
              _createElementVNode("a", {
                id: "teams-pill",
                role: "tab",
                class: _normalizeClass(["nav-link", { active: isExactActive }]),
                href: href,
                "aria-controls": "teams",
                "aria-selected": isExactActive,
                onClick: navigate
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "fas fa-users fa-fw" }, null, -1),
                _createTextVNode("My Teams ", -1)
              ]))], 10, _hoisted_5)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/me/billing",
            custom: ""
          }, {
            default: _withCtx(({ isActive, href, navigate }) => [
              _createElementVNode("a", {
                id: "billing-pill",
                role: "tab",
                class: _normalizeClass(["nav-link", { active: isActive }]),
                href: href,
                "aria-controls": "billing",
                "aria-selected": isActive,
                onClick: navigate
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "fas fa-credit-card fa-fw" }, null, -1),
                _createTextVNode("Billing ", -1)
              ]))], 10, _hoisted_7)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/me/settings",
            custom: ""
          }, {
            default: _withCtx(({ isActive, href, navigate }) => [
              _createElementVNode("a", {
                id: "settings-pill",
                role: "tab",
                class: _normalizeClass(["nav-link", { active: isActive }]),
                href: href,
                "aria-controls": "settings",
                "aria-selected": isActive,
                onClick: navigate
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fas fa-cogs fa-fw" }, null, -1),
                _createTextVNode("Settings ", -1)
              ]))], 10, _hoisted_9)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"row-fluid mt-5\"><ul class=\"nav nav-pills\"><li class=\"nav-item\"><a class=\"nav-link btn btn-outline-info text-left\" href=\"https://help.ganttproject.biz/t/ganttproject-cloud-docs/1954\" target=\"_blank\"><i class=\"fas fa-rocket fa-fw\"></i>Getting Started </a></li></ul></div>", 1))
  ]))
}